import { Code as CodeIcon } from '@mui/icons-material'
import { Chip } from '@mui/material'
import React from 'react'

// Function to get cookie value by name
const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null
  }
  return null
}

export const EnvironmentBadge: React.FC = () => {
  const [env, setEnv] = React.useState<string | null>(null)

  React.useEffect(() => {
    // Check ENV cookie
    const envValue = getCookie('ENV')
    // Only set env if we actually have a non-empty, non-prod value
    if (envValue?.trim() && envValue.toLowerCase() !== 'prod') {
      setEnv(envValue.toUpperCase())
    }
  }, [])

  // Don't render anything if env is null or 'prod'
  if (!env) {
    return null
  }

  // Determine color based on environment
  const getColor = () => {
    switch (env.toLowerCase()) {
      case 'dev':
      case 'development':
        return 'info'
      case 'beta':
      case 'staging':
        return 'warning'
      case 'test':
        return 'secondary'
      default:
        return 'default'
    }
  }

  return (
    <Chip
      icon={<CodeIcon />}
      label={env}
      size="small"
      color={getColor()}
      clickable
      component="a"
      href="/w3/ui-test.html"
      sx={{
        ml: 1,
        animation: 'pulse 2s infinite',
        '@keyframes pulse': {
          '0%': { opacity: 1 },
          '50%': { opacity: 0.7 },
          '100%': { opacity: 1 },
        },
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'none',
          filter: 'brightness(0.9)',
        },
      }}
    />
  )
}
